<template>
  <section class="text-black">
    <div class="flex justify-between items-center mb-5">
      <h4>{{ $t("objectives.titles.quiz") }}</h4>
      <Button
        id="finalize-quiz"
        :label="$t('labels.finalize')"
        :loading="loading"
        :disabled="course?.type === 'ADAPTATIVE' ? !actualId : false"
        class="btn-primary p-button-sm"
        @click="goToChapters"
        v-if="role === 'TEACHER'"
      />
    </div>
    <div class="flex flex-col gap-8">
      <FormQuiz
        :course="course"
        :data="data"
        :objective="objective"
        :role="role"
        @onAllow="onAllow"
        @onCreated="getId"
      />
      <Questions
        :questions="questions"
        :quizId="data?.id ?? actualId"
        :role="role"
        :objective="objective"
      />
    </div>
  </section>
</template>

<script lang="ts">
import { GoToRoute } from "@/utils/go-to.util";
import { defineAsyncComponent, defineComponent, PropType } from "vue";
import { ObjectiveService } from "../objective.service";

const FormQuiz = defineAsyncComponent(() => import("./FormQuiz/form-quiz.vue"));
const Questions = defineAsyncComponent(
  () => import("./Questions/questions.vue")
);

export default defineComponent({
  name: "quiz",
  emits: ["onAllow"],
  components: { FormQuiz, Questions },
  computed: {
    service(): ObjectiveService {
      return new ObjectiveService();
    },
    go(): GoToRoute {
      return new GoToRoute();
    },
  },
  props: {
    quizId: {
      type: String,
      default: "",
    },
    data: [Object],
    objective: [Object],
    course: [Object],
    questions: {
      type: Array as PropType<any>,
      default: [],
    },
    role: [String],
  },
  data() {
    return {
      actualId: "" as string,
      quiz: {} as any,
      loading: false as boolean,
    };
  },
  mounted() {
    this.getQuizData();
    this.getId(this.quizId);
  },
  methods: {
    goToChapters(): void {
      const params = {
        id: this.$route.params.courseId,
      };
      this.loading = true;

      setTimeout(() => {
        this.loading = false;
        this.go.redirectToPage("chapters", params);
      }, 500);
    },
    getQuizData(): void {
      this.quiz = this.data;
    },
    getId(event: any) {
      setTimeout(() => {
        this.actualId = this.quizId ?? event;
      }, 250);
    },
    onAllow(event: any): void {
      this.$emit("onAllow", event);
    },
  },
});
</script>
